module.exports = __webpack_public_path__ + "img/Kipper.e9a21397.svg";